interface CompactToolCtaProps {
    href: string
    label: string
    testId?: string
}

const CompactToolCta = ({ href, label, testId }: CompactToolCtaProps) => (
    <a className="rmc-cta" href={href} target="_blank" rel="noopener" data-testid={testId}>
        <span className="rmc-cta-r" aria-hidden="true">
            <svg
                viewBox="0 0 16 16"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 8h10M9 4l4 4-4 4" />
            </svg>
        </span>
        <span className="rmc-cta-t">{label}</span>
    </a>
)

export default CompactToolCta
